<div class="statusbar d-flex flex-column border-border" [class.status-border]="status?.length > 0">
  <div class="alert no-top fade show tr-banner no-round-left" [ngClass]="[state.type, 'alert-' + state.type]" *ngFor="let state of status">
    <ng-container *ngIf="isReload(state)">
      <ng-container *ngTemplateOutlet="reloadTemplate"></ng-container>
    </ng-container>

    <ng-container *ngIf="!isReload(state)">
      <div class="text-center">
        <span [innerHTML]="state.body"></span>
        <span
          *ngIf="state.link && (!state?.link?.visibility  || (state.link.visibility === paidService.billingsVisibility) || paidService.billingsVisibility === BillingVisibility.FULL)"
          (click)="navigate(state)"
          class="alert-link ml-1"
        >{{ state.link.name }}
        </span>

        <button type="button" *ngIf="state.dismissable" class="close ml-auto" (click)="close(state)" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #reloadTemplate>
  <strong>App update available:</strong> Please <strong><a class="alert-link" (click)="reload()">refresh</a></strong> your browser to get the latest experience.
</ng-template>
